import { CombinedDisconnects } from './autoTaskRow.ts';

interface Props {
    row: CombinedDisconnects;
    onClick: () => void;
}

export function DisconnectedTaskRow({ row, onClick }: Props) {
    return (
        <tr
            className={row.highlightClass}
            style={{ margin: '8px 8px', cursor: 'pointer' }}
            onClick={onClick}
            onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    onClick();
                }
            }}
            role='button'
            tabIndex={0}
        >
            <td colSpan={3} className='textAlignLeft tasks--large-text'>
                ({row.tasks.length})
                {row.coordinatesPreview.length > 0 && (
                    <>
                        {' '}
                        {row.coordinatesPreview}
                        {row.coordinatesRemainder > 0 && ` (+${row.coordinatesRemainder} more)`}
                    </>
                )}
            </td>
            <td className='tasks--large-text'>Disconnected</td>
        </tr>
    );
}
